/* ==========================================================================
   PRAETORIAN — theme.js
   Nav, panier Shopify (AJAX Cart API), reveal, tabs, accordion, variantes.
   Tout ce qui dépend du contenu d'une section passe par initSection(root),
   rappelé par l'éditeur de thème à chaque ajout/modification de section.
   ========================================================================== */
(function(){
  "use strict";

  const $  = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));
  const routes = Object.assign({
    root: "/", cart: "/cart", cartJs: "/cart.js", cartAdd: "/cart/add.js",
    cartChange: "/cart/change.js", allProducts: "/collections/all"
  }, window.themeRoutes || {});

  function escapeHtml(str){
    return String(str == null ? "" : str).replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]);
  }
  function fmtMoney(cents){
    const format = window.themeMoneyFormat || "€{{ amount }}";
    return format.replace(/\{\{\s*(amount[a-z_]*)\s*\}\}/, function(_, token){
      const noDecimals = token.indexOf("no_decimals") !== -1;
      let thousands = ",", decimal = ".";
      if (token.indexOf("comma_separator") !== -1) { thousands = "."; decimal = ","; }
      else if (token.indexOf("space_separator") !== -1) { thousands = " "; decimal = ","; }
      else if (token.indexOf("apostrophe_separator") !== -1) { thousands = "'"; decimal = "."; }
      const value = noDecimals ? Math.round(cents / 100) : (cents / 100);
      const str = noDecimals ? String(value) : value.toFixed(2);
      const parts = str.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts.join(decimal) : parts[0];
    });
  }
  function lockScroll(lock){ document.body.style.overflow = lock ? "hidden" : ""; }

  /* ---------------- Header scroll state ---------------- */
  const backToTop = $(".back-to-top");
  window.addEventListener("scroll", () => {
    const y = window.scrollY;
    const header = $(".site-header");
    if (header) header.classList.toggle("is-scrolled", y > 20);
    if (backToTop) backToTop.classList.toggle("show", y > 600);
  }, { passive: true });
  backToTop && backToTop.addEventListener("click", () => window.scrollTo({ top: 0, behavior: "smooth" }));

  /* ---------------- Mobile nav (délégation : survit au rechargement de la section en-tête) ---------------- */
  function toggleMobileNav(open){
    const burger = $(".burger");
    const mobileNav = $(".mobile-nav");
    const overlay = $(".mobile-nav-overlay");
    if (!mobileNav) return;
    const isOpen = open !== undefined ? open : !mobileNav.classList.contains("open");
    burger && burger.classList.toggle("active", isOpen);
    mobileNav.classList.toggle("open", isOpen);
    overlay && overlay.classList.toggle("open", isOpen);
    lockScroll(isOpen);
  }
  document.addEventListener("click", (e) => {
    if (e.target.closest(".burger")) { toggleMobileNav(); return; }
    if (e.target.closest(".mobile-nav-overlay") || e.target.closest("[data-close-mobile]")) { toggleMobileNav(false); return; }
  });
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    toggleMobileNav(false);
    closeCartDrawer();
  });

  /* ---------------- Mega menu (fermeture différée pour les mouvements de souris en diagonale) ---------------- */
  function initMegaMenu(root){
    $$(".main-nav > li", root).forEach(li => {
      if (!$(".mega", li)) return;
      let closeTimer;
      li.addEventListener("mouseenter", () => { clearTimeout(closeTimer); li.classList.add("mega-open"); });
      li.addEventListener("mouseleave", () => { closeTimer = setTimeout(() => li.classList.remove("mega-open"), 350); });
      li.addEventListener("focusin", () => { clearTimeout(closeTimer); li.classList.add("mega-open"); });
      li.addEventListener("focusout", () => {
        closeTimer = setTimeout(() => { if (!li.contains(document.activeElement)) li.classList.remove("mega-open"); }, 350);
      });
    });
  }

  /* ---------------- Scroll reveal ---------------- */
  function observeReveals(root){
    const els = $$("[data-reveal]", root);
    if (!els.length) return;
    if (window.Shopify && window.Shopify.designMode) { els.forEach(el => el.classList.add("revealed")); return; }
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.style.setProperty("--i", entry.target.dataset.i || 0);
            entry.target.classList.add("revealed");
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });
      els.forEach((el, i) => { el.dataset.i = el.dataset.i || (i % 6); io.observe(el); });
    } else {
      els.forEach(el => el.classList.add("revealed"));
    }
  }

  /* ---------------- Animated counters ---------------- */
  function animateCount(el){
    const raw = String(el.dataset.count || "").trim();
    const target = parseFloat(raw.replace(",", "."));
    const suffix = el.dataset.suffix || "";
    // Valeur non numérique (ex. "24h/24") : on l'affiche telle quelle
    if (isNaN(target) || !/^-?\d+([.,]\d+)?$/.test(raw)) { el.textContent = raw + suffix; return; }
    const decimals = (raw.split(/[.,]/)[1] || "").length;
    const duration = 1400;
    const start = performance.now();
    function tick(now){
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      const val = decimals ? (eased * target) : Math.floor(eased * target);
      el.textContent = val.toLocaleString("fr-FR", { minimumFractionDigits: decimals, maximumFractionDigits: decimals }) + suffix;
      if (p < 1) requestAnimationFrame(tick);
      else el.textContent = target.toLocaleString("fr-FR", { minimumFractionDigits: decimals, maximumFractionDigits: decimals }) + suffix;
    }
    requestAnimationFrame(tick);
  }
  function initCounters(root){
    const counters = $$("[data-count]", root);
    if (!counters.length) return;
    if (!("IntersectionObserver" in window) || (window.Shopify && window.Shopify.designMode)) {
      counters.forEach(animateCount);
      return;
    }
    const ioCount = new IntersectionObserver((entries) => {
      entries.forEach(entry => { if (entry.isIntersecting) { animateCount(entry.target); ioCount.unobserve(entry.target); } });
    }, { threshold: 0.5 });
    counters.forEach(c => ioCount.observe(c));
  }

  /* ---------------- Toast ---------------- */
  let toastTimer;
  function showToast(msg){
    let toast = $(".toast");
    if (!toast) {
      toast = document.createElement("div");
      toast.className = "toast";
      toast.setAttribute("role", "status");
      toast.innerHTML = '<span class="dot"></span><span class="toast-msg"></span>';
      document.body.appendChild(toast);
    }
    $(".toast-msg", toast).textContent = msg;
    toast.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove("show"), 3200);
  }
  window.PraetorianToast = showToast;

  /* ==========================================================================
     PANIER — Shopify AJAX Cart API
     ========================================================================== */
  function renderCartDrawer(cart){
    const body = $(".cart-drawer-body");
    const foot = $(".cart-drawer-foot");
    $$(".cart-count").forEach(el => { el.textContent = cart.item_count; el.style.display = cart.item_count ? "flex" : "none"; });
    if (!body) return;

    if (!cart.item_count) {
      body.innerHTML = '<div class="cart-empty">Votre panier est vide.<br>Direction la boutique !</div>';
      if (foot) foot.style.display = "none";
      return;
    }
    if (foot) foot.style.display = "grid";

    body.innerHTML = cart.items.map(item => {
      const img = item.image ? item.image + (item.image.indexOf("?") === -1 ? "?" : "&") + "width=160" : "";
      const variant = item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";
      return `
      <div class="cart-item" data-key="${escapeHtml(item.key)}">
        <a href="${escapeHtml(item.url)}">${img ? `<img src="${escapeHtml(img)}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : '<span class="cart-item-noimg"></span>'}</a>
        <div>
          <h4><a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a></h4>
          ${variant ? `<div style="font-size:12px;color:var(--gray-500);margin-bottom:6px;">${escapeHtml(variant)}</div>` : ""}
          <div class="price">${fmtMoney(item.final_price)}</div>
          <div class="qty-stepper" style="margin-top:8px;">
            <button type="button" data-action="dec" aria-label="Retirer un">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-action="inc" aria-label="Ajouter un">+</button>
          </div>
        </div>
        <div style="text-align:right;">
          <div style="font-weight:800;">${fmtMoney(item.final_line_price)}</div>
          <button type="button" class="remove-item" data-action="remove">Retirer</button>
        </div>
      </div>`;
    }).join("");

    if (foot) {
      foot.innerHTML = `
        <div class="flex-between"><span style="color:var(--gray-300);font-size:14px;">Sous-total</span><b style="font-family:var(--font-display);font-size:20px;">${fmtMoney(cart.total_price)}</b></div>
        <p style="font-size:12px;color:var(--gray-500);">Frais de livraison calculés à l'étape suivante.</p>
        <a href="${routes.root.replace(/\/?$/, "/")}checkout" class="btn btn-neon btn-block">Passer commande</a>
        <a href="${routes.cart}" class="btn btn-outline btn-block">Voir le panier</a>
      `;
    }
  }

  function fetchCart(){
    return fetch(routes.cartJs, { headers: { "Accept": "application/json" } }).then(r => r.json());
  }
  function refreshCart(){
    return fetchCart().then(renderCartDrawer).catch(() => {});
  }
  function handleCartResponse(r){
    return r.json().then(data => {
      if (!r.ok || data.status) {
        showToast(data.description || data.message || "Action impossible sur ce produit.");
        return Promise.reject(data);
      }
      return data;
    });
  }
  function addToCart(id, quantity){
    return fetch(routes.cartAdd, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: quantity || 1 }] })
    }).then(handleCartResponse).then(data => {
      const item = (data.items && data.items[0]) || data;
      showToast((item.product_title || "Produit") + " ajouté au panier");
      if (window.themeCartType === "page") { window.location.href = routes.cart; return; }
      openCartDrawer();
      return refreshCart();
    });
  }
  function changeLine(key, quantity){
    return fetch(routes.cartChange, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(handleCartResponse).then(cart => {
      renderCartDrawer(cart);
      // Sur la page panier, on recharge pour garder les totaux synchronisés
      if (document.body.classList.contains("template-cart")) window.location.reload();
    }).catch(() => refreshCart());
  }
  window.PraetorianCart = { addToCart, changeLine, refreshCart };

  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".cart-drawer-body [data-action]");
    if (!btn) return;
    const item = btn.closest(".cart-item");
    const key = item.dataset.key;
    let qty = parseInt($(".qty-stepper span", item).textContent, 10);
    if (btn.dataset.action === "inc") qty += 1;
    if (btn.dataset.action === "dec") qty -= 1;
    if (btn.dataset.action === "remove") qty = 0;
    $$("button", item).forEach(b => b.disabled = true);
    changeLine(key, Math.max(qty, 0));
  });

  /* Ouverture / fermeture du panier latéral */
  function openCartDrawer(){
    const drawer = $(".cart-drawer");
    if (!drawer) return;
    drawer.classList.add("open");
    const overlay = $(".cart-drawer-overlay");
    overlay && overlay.classList.add("open");
    lockScroll(true);
  }
  function closeCartDrawer(){
    const drawer = $(".cart-drawer");
    if (!drawer || !drawer.classList.contains("open")) return;
    drawer.classList.remove("open");
    const overlay = $(".cart-drawer-overlay");
    overlay && overlay.classList.remove("open");
    lockScroll(false);
  }
  document.addEventListener("click", (e) => {
    const opener = e.target.closest("[data-open-cart]");
    if (opener) {
      // Mode "page panier" ou déjà sur la page panier : on laisse le lien fonctionner normalement
      if (window.themeCartType === "page" || document.body.classList.contains("template-cart")) return;
      e.preventDefault();
      toggleMobileNav(false);
      refreshCart();
      openCartDrawer();
      return;
    }
    if (e.target.closest("[data-close-cart]") || e.target.closest(".cart-drawer-overlay")) closeCartDrawer();
  });

  refreshCart();

  /* Ajout rapide depuis les cartes produit */
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-quickadd]");
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    addToCart(btn.dataset.quickadd, 1).catch(() => {}).finally(() => { btn.disabled = false; });
  });

  /* ---------------- Fiche produit (variantes + ajout au panier) ---------------- */
  function initProductForms(root){
    $$("[data-product-form]", root).forEach(form => {
      if (form.dataset.bound) return;
      form.dataset.bound = "1";
      let productJson;
      try {
        productJson = JSON.parse($("[data-product-json]", form).textContent);
      } catch (err) {
        return;
      }
      const submitBtn = $("[data-add-to-cart]", form);
      const container = form.closest(".product-detail") || document;
      const priceEl = $("[data-price]", container);
      const comparePriceEl = $("[data-compare-price]", container);
      const skuEl = $("[data-sku]", container);
      const idInput = $("[data-variant-id]", form);
      const selectedOptions = {};

      $$("[data-option-value]", form).forEach(btn => {
        if (btn.classList.contains("active")) selectedOptions[btn.dataset.optionName] = btn.dataset.optionValue;
      });

      function findVariant(){
        return productJson.variants.find(v => v.options.every((val, i) => selectedOptions[productJson.options[i]] === val));
      }
      function updateForVariant(){
        const variant = findVariant();
        if (!variant) { submitBtn.disabled = true; submitBtn.textContent = "Combinaison indisponible"; return; }
        idInput.value = variant.id;
        if (priceEl) priceEl.textContent = fmtMoney(variant.price);
        if (comparePriceEl) {
          const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
          comparePriceEl.textContent = onSale ? fmtMoney(variant.compare_at_price) : "";
          comparePriceEl.style.display = onSale ? "" : "none";
        }
        if (skuEl && variant.sku) skuEl.textContent = variant.sku.toUpperCase();
        if (variant.available) {
          submitBtn.disabled = false;
          submitBtn.textContent = "Ajouter au panier — " + fmtMoney(variant.price);
        } else {
          submitBtn.disabled = true;
          submitBtn.textContent = "Rupture de stock";
        }
        const mainImg = $("#mainImg", container);
        if (mainImg && variant.featured_image) mainImg.src = variant.featured_image.src;
        // Met à jour l'URL (?variant=) pour que le lien partagé ouvre la bonne variante
        if (window.history && window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set("variant", variant.id);
          window.history.replaceState({}, "", url.toString());
        }
      }

      $$("[data-option-value]", form).forEach(btn => {
        btn.addEventListener("click", () => {
          const group = btn.closest("[data-option-group]");
          $$("[data-option-value]", group).forEach(b => b.classList.remove("active"));
          btn.classList.add("active");
          selectedOptions[btn.dataset.optionName] = btn.dataset.optionValue;
          updateForVariant();
        });
      });

      const qtyVal = $("[data-qty-val]", form);
      const incBtn = $("[data-qty-inc]", form);
      const decBtn = $("[data-qty-dec]", form);
      incBtn && incBtn.addEventListener("click", () => { qtyVal.textContent = parseInt(qtyVal.textContent, 10) + 1; });
      decBtn && decBtn.addEventListener("click", () => {
        const v = parseInt(qtyVal.textContent, 10);
        if (v > 1) qtyVal.textContent = v - 1;
      });

      form.addEventListener("submit", (e) => {
        e.preventDefault();
        const qty = qtyVal ? parseInt(qtyVal.textContent, 10) : 1;
        submitBtn.disabled = true;
        addToCart(idInput.value, qty).catch(() => {}).finally(() => {
          if (productJson.variants.length > 1) updateForVariant();
          else submitBtn.disabled = false;
        });
      });
    });

    /* Galerie */
    $$(".gallery-thumbs", root).forEach(gallery => {
      $$("img", gallery).forEach(thumb => {
        thumb.addEventListener("click", () => {
          $$("img", gallery).forEach(t => t.classList.remove("active"));
          thumb.classList.add("active");
          const mainImg = $("#mainImg");
          if (mainImg) mainImg.src = thumb.dataset.src;
        });
      });
    });

    /* Onglets */
    $$(".tab-btn", root).forEach(btn => {
      btn.addEventListener("click", () => {
        const tabs = btn.closest(".pd-tabs");
        $$(".tab-btn", tabs).forEach(b => b.classList.remove("active"));
        $$(".tab-panel", tabs).forEach(p => p.classList.remove("active"));
        btn.classList.add("active");
        const panel = $("#" + btn.dataset.tab, tabs);
        panel && panel.classList.add("active");
      });
    });
  }

  /* ---------------- FAQ accordéon ---------------- */
  function initAccordions(root){
    $$(".accordion-item", root).forEach(item => {
      const trigger = $(".accordion-trigger", item);
      const panel = $(".accordion-panel", item);
      if (!trigger || !panel) return;
      if (item.classList.contains("open")) panel.style.maxHeight = panel.scrollHeight + "px";
      trigger.addEventListener("click", () => {
        const isOpen = item.classList.contains("open");
        $$(".accordion-item.open", item.parentElement).forEach(other => {
          if (other !== item) { other.classList.remove("open"); $(".accordion-panel", other).style.maxHeight = null; }
        });
        item.classList.toggle("open", !isOpen);
        trigger.setAttribute("aria-expanded", String(!isOpen));
        panel.style.maxHeight = !isOpen ? panel.scrollHeight + "px" : null;
      });
    });

    $$("[data-faq-search]", root).forEach(input => {
      const scope = input.closest("section") || document;
      input.addEventListener("input", () => {
        const q = input.value.trim().toLowerCase();
        $$(".accordion-item", scope).forEach(item => {
          item.style.display = item.textContent.toLowerCase().includes(q) ? "" : "none";
        });
        // Masque les titres de groupe dont toutes les questions sont filtrées
        $$("[data-faq-group]", scope).forEach(group => {
          const visible = $$(".accordion-item", group).some(i => i.style.display !== "none");
          group.style.display = visible ? "" : "none";
        });
      });
    });
  }

  /* ---------------- Filtres collection ---------------- */
  function initFilters(root){
    // Sur mobile / tablette portrait, les filtres sont repliés pour laisser voir les produits
    $$("[data-filters-details]", root).forEach(d => {
      const mq = window.matchMedia("(max-width: 900px)");
      const sync = () => { if (mq.matches) d.removeAttribute("open"); else d.setAttribute("open", ""); };
      sync();
      mq.addEventListener ? mq.addEventListener("change", sync) : mq.addListener(sync);
    });
    $$("[data-price-range]", root).forEach(range => {
      const out = $("[data-price-out]", range.closest(".filter-group"));
      range.addEventListener("input", () => { if (out) out.textContent = range.value + " " + (range.dataset.symbol || ""); });
      range.addEventListener("change", () => range.form && range.form.submit());
    });
    $$("[data-sort-select]", root).forEach(select => {
      select.addEventListener("change", () => {
        const url = new URL(window.location.href);
        url.searchParams.set("sort_by", select.value);
        url.searchParams.delete("page");
        window.location.href = url.toString();
      });
    });
  }

  /* ---------------- Vidéo intégrée (YouTube / Vimeo) ---------------- */
  function initVideos(root){
    $$("[data-video-embed]", root).forEach(frame => {
      frame.addEventListener("click", (e) => {
        e.preventDefault();
        const src = frame.dataset.videoEmbed;
        frame.innerHTML = `<iframe src="${escapeHtml(src)}" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen title="Vidéo"></iframe>`;
        frame.classList.add("is-playing");
      }, { once: true });
    });
  }

  function initSection(root){
    root = root || document;
    initMegaMenu(root);
    observeReveals(root);
    initCounters(root);
    initProductForms(root);
    initAccordions(root);
    initFilters(root);
    initVideos(root);
    $$("[data-year]", root).forEach(el => el.textContent = new Date().getFullYear());
  }
  initSection(document);

  /* ---------------- Éditeur de thème Shopify ---------------- */
  document.addEventListener("shopify:section:load", (e) => {
    initSection(e.target);
    if ($(".cart-count", e.target)) refreshCart();
  });
  document.addEventListener("shopify:section:unload", () => { toggleMobileNav(false); closeCartDrawer(); });

  /* ---------------- Newsletter : confirmation après inscription ---------------- */
  const newsletterSuccess = $("[data-newsletter-success]");
  if (newsletterSuccess) {
    showToast("Merci, vous rejoignez la légion.");
    const block = newsletterSuccess.closest("[data-reveal]");
    block && block.classList.add("revealed");
    newsletterSuccess.scrollIntoView({ block: "center" });
  }

})();
